import ramSchema from './Assets/RAM.svg';
import './CSS/laRam.scss';

export default function CoursLaRam()
{
    return (
        <div className='Page'>
            <h1>La RAM</h1>

            <p>
                De base, le VG5000 dispose de 16Ko de RAM.<br/>
                Seules les adresses de #4000 à #7FFF sont disponibles.<br/>
            </p>
            <p>
                Sous basic la zone basse de cette RAM est amputée de 2000 octets correspondants à un tampon vidéo que le système recopie dans la VRAM de l'EF9345 de temps en temps.<br/>
                Cette zone correspond aux adresses #4000/#47D0.<br/>
                Il reste donc peu de place pour coder si l'on souhaite preserver le basic (13758 octets).<br/>
                Heureusement pour nous cette mémoire peut-être étendue à 48Ko.<br/>
            </p>
            <p>
                L'ajout de RAM se fera par blocs de 16Ko respectivement en #8000 puis en #C000.
            </p>
            <p>
                Enfin précisons le tout de même, la zone #0000/#3FFF est occupée par la ROM.<br/>
                Il est donc impossible d'y écrire...
            </p>

            <p>
            <img className="ramSchema" src={ramSchema} alt="ram Schema"  />
            </p>

            <p>
                Afin de developper sur VG5000 je ne saurai que trop vous conseiller d'augmenter la RAM.<br/>
                Vous pourrez le faire à l'aide d'extensions telles que la VG5216 ou la cartouche VY5040.
            </p>

        </div>
    )
}